import React from 'react';
import './home-styles/home-section3.scss';

const HomeSection3 = () =>{
    return(
        <div className='home-section3'>
            <div className='section dark-section'>
                <div className='heading-section'>
                    <h3>WHO CAN JOIN ?</h3>
                </div>
                <div className='row'>
                    <div className='sub-heading-text'>
                        <p>Our program is idle for:</p>
                    </div>
                    <div className='sub-heading-content'>
                        <ul>
                            <li>8th qualification is enough ( written Tamil or state language & speech must)</li>
                            <li>Degree final year students & finished students.</li>
                            <li> NRI People (who are ready to invest in pawn shop)</li>
                            <li> Additional income require peoples</li>
                            <li>Home makers</li>
                            <li>Jewellery shop staffs.</li>
                            <li>Business owners & entrepreneurs.</li>
                            <li>Bank & NBFC Employees.</li>
                            <li>Engineering students etc.</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>

    );
};

export default HomeSection3;